import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-container wrap-v-medium" }
const _hoisted_2 = { class: "grid__row menu__navigation" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon--store" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon--navicon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'SARHome' } }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(_toDisplayString(_ctx.$t("labeltext.NavigationHome")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'SARReport' } }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(_toDisplayString(_ctx.$t("labeltext.NavigationReports")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}